export default {
  tenant: 'Mandant',
  tenants: 'Mandanten',
  tenantsOf: '{{type}}-Mandanten',
  'tenant.name': 'Mandantenname',
  'tenant.description': 'Zusätzliche Informationen zum Mandanten oder Projekt',
  'tenant.verification': 'KYB-Verifizierungsstufe',
  'tenant.kyb.basic': 'Basis (nur E-Mail)',
  'tenant.kyb.standard': 'Standard (E-Mail + Telefon)',
  'tenant.kyb.premium': 'Premium (vollständige Verifizierung)',
  'tenant.list.title': 'Mandantenverwaltung',
  'tenant.list.subtitle':
    'Verwalten Sie die Mandanten Ihrer Anwendung effektiv.',
  'tenant.list.search.placeholder':
    'Mandanten nach Name oder Beschreibung suchen',
  'tenant.info': 'Mandanteninformationen',
  'tenant.form.title': 'Mandantentitel',
  'tenant.form.description': 'Mandantenbeschreibung',
  'tenant.form.assignments': 'Zuweisungen',
  'tenant.info.helper':
    'Geben Sie einen klaren Titel, eine prägnante Beschreibung und einen passenden Typ zur Definition des Mandanten an',
  'tenant.api': 'API-Einstellungen',
  'tenant.api.helper': 'API-Einstellungen für den Mandanten konfigurieren',
  'tenant.api.origins': 'Erlaubte Origins (CORS)',
  'tenant.api.origins.helper':
    'Vollständige Origins, die API-Anfragen stellen dürfen. Format: http(s)://host[:port] — z.B. https://example.com, http://localhost:5173, https://*.example.com. Leer lassen, um alle zuzulassen. Verwende "*", um jeden Origin zuzulassen (nicht empfohlen).',
  'tenant.api.origins.wildcard.warning':
    'Achtung: "*" erlaubt Anfragen von JEDEM Origin. Dies deaktiviert den CORS-Schutz für diesen Mandanten — nur für öffentliche, nicht sensible Daten verwenden.',
  'tenant.api.origins.invalid':
    'Ungültige Origin(s): {{values}}. Jeder Eintrag muss "*" sein oder mit http:// oder https:// beginnen und einen Host (und optionalen Port) enthalten.',
  'tenant.api.limit': 'Monatliches Anfragenlimit',
  'tenant.api.expiration': 'API-Key-Ablaufdatum',
  'tenant.api.active': 'Aktiver Schlüssel',
  'tenant.api.active.on': 'Aktiv',
  'tenant.api.active.off': 'Inaktiv',
  'tenant.api.token.info':
    'Erstellen Sie einen feingranularen, auf {name} beschränkten Token für die persönliche API-Nutzung',
  'tenant.api.token.helper': 'Der Token läuft am ausgewählten Datum ab',
  'tenant.api.name.helper':
    'Ein eindeutiger Name für diesen Mandanten. Kann für Ressourcen-Besitzer oder Benutzer im Besitz des Tokens sichtbar sein.',
  'tenant.api.subscriptions.available': 'Verfügbare Abonnements',
  'tenant.api.subscriptions.available.placeholder':
    'Wählen Sie die für diesen Mandanten verfügbaren Abonnements',
  'tenant.api.generateKey': 'Neuen API-Schlüssel generieren',
  'tenant.api.handleKey': 'API-Schlüssel verwalten',
  'tenant.api.keyCreated': 'API-Schlüssel erfolgreich erstellt',
  'tenant.api.keyCopied': 'API-Schlüssel in die Zwischenablage kopiert',
  'tenant.api.keys.title': 'API-Schlüssel',
  'tenant.api.keys.delete.confirm':
    'Möchten Sie diesen API-Schlüssel wirklich löschen?',
  'tenant.api.keys.activate.confirm':
    'Möchten Sie diesen API-Schlüssel wirklich aktivieren?',
  'tenant.api.keys.deactivate.confirm':
    'Möchten Sie diesen API-Schlüssel wirklich deaktivieren?',
  'tenant.api.keys.delete.success': 'API-Schlüssel erfolgreich gelöscht',
  'tenant.api.keys.deactivate.success': 'API-Schlüssel erfolgreich deaktiviert',
  'tenant.api.keys.noKeys': 'Keine API-Schlüssel gefunden',
  'tenant.api.keys.usageCount': 'Nutzungsanzahl',
  'tenant.api.keys.info.attention': 'Achtung!',
  'tenant.api.keys.info.attention.alert':
    'Teilen Sie diesen Schlüssel nicht mit Dritten. Wenn der Schlüssel kompromittiert ist, widerrufen Sie ihn sofort im Verwaltungspanel.',
  'tenant.api.keys.info.attention.helper':
    'Bitte speichern Sie diesen API-Schlüssel. Er wird im System nicht erneut angezeigt.',
};
